import React from 'react'
import PropTypes from 'prop-types'
import { Provider, inject, observer } from 'mobx-react'
import Store from './stores/Store.js'
import EmployeeThumbnail from './components/EmployeeThumbnail'


@inject("widgetStore")
@observer
export default class EmployeeGallery extends React.Component {
  static propTypes = {
    widgetStore: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool,
    bookNowButtonText: PropTypes.string
  }

  static defaultProps = {
    showBookNowButton: true,
    bookNowButtonText: "Book Now"
  }

  employeeStore = new Store({ widgetStore: this.props.widgetStore })

  componentDidMount() {
    this.employeeStore.setup()
  }

  render() {
    const { employeeStore } = this
    const { showBookNowButton, bookNowButtonText } = this.props
    const { ready, loading, employees } = employeeStore

    if(!ready) {
      return null
    }
    else if(loading) {
      return (
        <div>Loading...</div>
      )
    }
    else {
      return (
        <Provider store={employeeStore}>
          <div style={styles.wrapper}>
            <div style={styles.employeeContainer}>
              { employeeStore.employees.map(employee =>
                <EmployeeThumbnail
                  key={employee.id}
                  employee={employee}
                  style={styles.employee}
                  showBookNowButton={showBookNowButton}
                  bookNowButtonText={bookNowButtonText}
                />
              )}
            </div>
          </div>
        </Provider>
      )
    }
  }
}

const styles = {
  wrapper: {
    maxWidth: "100%"
  },
  employeeContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center"
  },
  employee: {
    width: 300
  }
}
